import type { AdminRepository } from '@/modules/ctx-admin-functions';
import type { DataApi } from '@/modules/shared/adapter';
import { UploadCSVDataTypeEnum } from '@/modules/shared/adapter';

export class AdminRepositoryImpl implements AdminRepository {

    private readonly dataApi: DataApi;

    constructor(apis: {
        data: DataApi,
    }) {
        this.dataApi = apis.data;
    }

    public async uploadPlanDataCSV(blob: Blob): Promise<string> {
        return await this.dataApi.uploadDataCSV(UploadCSVDataTypeEnum.MonthlyPlan, blob);
    }

    public async uploadPlanBasicDataCSV(blob: Blob): Promise<string> {
        return await this.dataApi.uploadDataCSV(UploadCSVDataTypeEnum.MonthlyPlanBasicData, blob);
    }

    public async uploadCommissionMarketvaluesCSV(blob: Blob): Promise<string> {
        return await this.dataApi.uploadDataCSV(UploadCSVDataTypeEnum.CommissionMarketvalues, blob);
    }

    public async uploadEnergyIndexPlzIwetCSV(blob: Blob): Promise<string> {
        return await this.dataApi.uploadDataCSV(UploadCSVDataTypeEnum.EnergyIndexPlzIwet, blob);
    }

    public async uploadEnergyIndexValueIwetCSV(blob: Blob, year: number): Promise<string> {
        return await this.dataApi.uploadDataCSV2(UploadCSVDataTypeEnum.EnergyIndexValueIwet, blob, year);
    }
}
